// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","card--clickable":"Card_card--clickable__4N1kh","appear":"Card_appear__SdxQl"};